import * as types from './mutation-types'

const mutations = {
    [types.SET_LOCATION](state, data) {
        state.location_Provices = data.Province.sort((a, b) => a.province_name.localeCompare(b.province_name, 'zh'));
        state.location_Citys = data.City
    },
    [types.SET_FLOWCATEGORY](state, data) {
        state.flow_category = data
    },
    [types.SET_FLOWTYPE](state, data) {
        state.flowtype = data
    },
    [types.SET_QUERYFLOWTYPE](state, data) {
        state.queryflowtype = data
    },
    [types.SET_PRODUCTPARENTLIST](state, data) {
        state.productParentList = data
    },
    [types.SET_PRODUCTLINEPARENTLIST](state, data) {
        state.productParentLineList = data
    },
    [types.SET_BU](state, data) {
        state.BU = data
    },
    [types.SET_COMMON](state, data) {
        state.Global_Config = data.sort((a, b) => a.code - b.code);
    },
    [types.SET_USER](state, data) {
        state.user = data
    },
    [types.SET_HOSIPITALS](state, data) {
        state.hosipitals = data
    },
    [types.SET_VALIDATERESULT](state, data) {
        state.validateResult = data
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js